import { users } from '@/api'
import { getCopy } from '@/services/tools'

const getUsers = async (context, { page, search }) => {
  context.commit('LOADING_UPDATED', true)
  try {
    let response = await users.fetch({ page, search })
    const formattedUsers = response.data['hydra:member'].map(user => ({
      id: user.id,
      email: user.username,
      roles: user.roles,
      products: user.products,
      customerId: user.customer,
      createdAt: new Date(user.createdAt)
    }))
    context.commit('USERS_UPDATED', formattedUsers)
  } catch (e) {
    context.dispatch('auth/checkStatus', e.response && e.response.status, { root: true })
  } finally {
    context.commit('LOADING_UPDATED', false)
  }
}
const getUser = async (context, id) => {
  context.commit('LOADING_UPDATED', true)
  context.commit('USER_UPDATED', getCopy(context.state.models.user))
  try {
    let response = await users.fetchOne(id)
    // Get the most priviledged role
    response.data.role = response.data.roles.pop()
    context.commit('USER_UPDATED', response.data)
    return response
  } catch (e) {
    context.dispatch('auth/checkStatus', e.response.status, { root: true })
    throw e
  } finally {
    context.commit('LOADING_UPDATED', false)
  }
}

const createUser = async (context, user) => {
  context.commit('LOADING_UPDATED', true)
  user.language = 'fr'
  user.roles = [user.role]
  user.timeZone = 'UTC+2'
  try {
    let response = await users.create(user)
    return response.data.id
  } catch (e) {
    context.dispatch('auth/checkStatus', e.response.status, { root: true })
    throw e
  } finally {
    context.commit('LOADING_UPDATED', false)
  }
}

const updateUser = async (context, user) => {
  context.commit('LOADING_UPDATED', true)
  user.language = 'fr'
  user.roles = [user.role]
  user.timeZone = 'UTC+2'
  if (user.plainPassword) { user.password = 'newpassword' } // Hack to force password update
  try {
    let response = await users.update(user.id, user)
    return response.data.id
  } catch (e) {
    context.dispatch('auth/checkStatus', e.response.status, { root: true })
    throw e
  } finally {
    context.commit('LOADING_UPDATED', false)
  }
}

const deleteUser = async (context, id) => {
  context.commit('LOADING_UPDATED', true)
  context.commit('USER_UPDATED', getCopy(context.state.models.user))
  try {
    let response = await users.delete(id)
    // remove user from the state
    context.commit('USERS_UPDATED', context.state.users.filter(user => user.id !== id))
    return response
  } catch (e) {
    context.dispatch('auth/checkStatus', e.response.status, { root: true })
    throw e
  } finally {
    context.commit('LOADING_UPDATED', false)
  }
}

export default {
  getUsers,
  getUser,
  createUser,
  updateUser,
  deleteUser
}



// WEBPACK FOOTER //
// ./src/store/modules/users/actions.js